import { LOCALES } from 'src/constants';

export const getGalleryImageAltSuffix = (index: number, imagesCount: number) => {
  return imagesCount > 1 ? `. ${LOCALES.PHOTO} ${index + 1}` : ``;
};
